// Used U.
const PILLARS_GOALS_ANSWERS_TEMPLATE = {
    Community: {
        text: 'Are there any aspects of your community pillar you would like to improve?',
        answers: [
            // tags from BE will be added here
        ],
    },
    Exercise: {
        text: 'Are there any aspects of your exercise you would like to improve?',
        answers: [
            // tags from BE will be added here
        ],
    },
    MeaningfulActivity: {
        text: 'Are there any aspects of your meaningful activity pillar you would like to improve?',
        answers: [
            // tags from BE will be added here
        ],
    },
    Nutrition: {
        text: 'Are there any aspects of your nutrition you would like to improve?',
        answers: [
            // tags from BE will be added here
        ],
    },
    Sleep: {
        text: 'Are there any aspects of your sleep you would like to improve?',
        answers: [
            // tags from BE will be added here
        ],
    },
    StressManagement: {
        text: 'Are there any aspects of your stress management you would like to improve?',
        answers: [
            // tags from BE will be added here
        ],
    },
}

const PILLARS = {
    CO: 'Community',
    EX: 'Exercise',
    MA: 'MeaningfulActivity',
    N: 'Nutrition',
    SL: 'Sleep',
    SM: 'StressManagement',
}

export const transformGoalTagsIntoPillarsGoals = ({ template = PILLARS_GOALS_ANSWERS_TEMPLATE, goalTags = [] }) => {
    const body = { ...template }

    goalTags
        .filter(({ active = true }) => active) // !Show in addGoal only active goalsTags
        .forEach(({ label, value, weight = 0 }, index) => {
            const pillar = value.split('_')[0]
            const key = PILLARS[pillar]

            const tag = { id: index, tag: value, text: label, weight }
            if (body[key] && !body[key].answers.includes(tag)) {
                body[key].answers.push(tag)
            }
        })

    /**
     * If you try to understand it - good luck :)
     * The code below prevents duplicate tags in the answers array of each pillar
     */
    return Object.fromEntries(
        Object.entries(body).map(([key, value]) => [
            key,
            {
                ...value,
                answers: Array.from(new Map(value.answers.map(item => [item.tag, item])).values()),
            },
        ])
    )
}
